// Mirror of backend logic — used to show/hide action buttons
export const ALLOWED_TRANSITIONS = {
  'Pending':     ['In Progress', 'Cancelled'],
  'In Progress': ['Ready', 'Cancelled'],
  'Ready':       ['Delivered', 'Cancelled'],
  'Delivered':   [],
  'Cancelled':   [],
};

export const ACTION_BUTTON_LABELS = {
  'Pending':     'Start Work',
  'In Progress': 'Mark Ready',
  'Ready':       'Mark Delivered',
};

export function getNextStatus(currentStatus) {
  const transitions = ALLOWED_TRANSITIONS[currentStatus];
  // Return first non-Cancelled transition
  return transitions.find(s => s !== 'Cancelled') || null;
}